if (!customElements.get('meridiana-offers')) {
  customElements.define('meridiana-offers', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.viewport = this.querySelector('[data-offers-viewport]');
      this.slides = [...this.querySelectorAll('[data-offer]')];
      this.index = 0;
      this.manualPause = this.dataset.autoplay !== 'true' || matchMedia('(prefers-reduced-motion: reduce)').matches || Boolean(window.Shopify?.designMode);
      this.hover = false;
      this.focused = false;
      this.inView = true;
      this.toggle = this.querySelector('[data-toggle]');
      if (this.slides.length < 2) return;
      this.querySelector('[data-offers-controls]').hidden = false;
      this.querySelector('[data-dots]').replaceChildren();
      this.dots = this.slides.map((slide, index) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.setAttribute('aria-label', `${index + 1}: ${slide.getAttribute('aria-label')}`);
        button.addEventListener('click', () => this.go(index, true), {signal});
        this.querySelector('[data-dots]').append(button);
        return button;
      });
      this.querySelector('[data-previous]').addEventListener('click', () => this.go(this.index - 1, true), {signal});
      this.querySelector('[data-next]').addEventListener('click', () => this.go(this.index + 1, true), {signal});
      this.toggle.addEventListener('click', () => {this.manualPause = !this.manualPause; this.refreshTimer();}, {signal});
      this.addEventListener('pointerenter', event => {if (event.pointerType === 'mouse') {this.hover = true; this.refreshTimer();}}, {signal});
      this.addEventListener('pointerleave', () => {this.hover = false; this.refreshTimer();}, {signal});
      this.addEventListener('focusin', () => {this.focused = true; this.refreshTimer();}, {signal});
      this.addEventListener('focusout', event => {this.focused = this.contains(event.relatedTarget); this.refreshTimer();}, {signal});
      this.viewport.addEventListener('pointerdown', () => {this.manualPause = true; this.refreshTimer();}, {passive:true, signal});
      this.viewport.addEventListener('wheel', () => {this.manualPause = true;this.refreshTimer();}, {passive:true, signal});
      this.viewport.addEventListener('keydown', event => {if (['ArrowLeft','ArrowRight'].includes(event.key)) {event.preventDefault();this.go(this.index + (event.key === 'ArrowRight' ? 1 : -1), true);}}, {signal});
      this.viewport.addEventListener('scroll', () => {clearTimeout(this.scrollTimer);this.scrollTimer = setTimeout(() => {this.index = Math.max(0, Math.min(this.slides.length - 1, Math.round(this.viewport.scrollLeft / this.viewport.clientWidth)));this.update();}, 160);}, {passive:true, signal});
      document.addEventListener('visibilitychange', () => this.refreshTimer(), {signal});
      document.addEventListener('shopify:block:select', event => {const index = this.slides.findIndex(slide => slide === event.target || slide.contains(event.target));if (index >= 0) this.go(index, true);}, {signal});
      this.observer = new IntersectionObserver(entries => {this.inView = entries[0].isIntersecting;this.refreshTimer();});
      this.observer.observe(this);
      this.update();this.refreshTimer();
    }
    go(index, manual) {
      if (manual) {this.manualPause = true;this.querySelector('[data-offers-status]').setAttribute('aria-live','polite');}
      this.index = (index + this.slides.length) % this.slides.length;
      this.viewport.scrollTo({left:this.viewport.clientWidth * this.index,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      this.update();this.refreshTimer();
    }
    update() {
      this.slides.forEach((slide, index) => {slide.inert = index !== this.index;slide.setAttribute('aria-hidden', index !== this.index ? 'true' : 'false');});
      this.dots.forEach((dot,index) => dot.setAttribute('aria-current', index === this.index ? 'true' : 'false'));
      this.querySelector('[data-counter]').textContent = `${this.index + 1} / ${this.slides.length}`;
      this.querySelector('[data-offers-status]').textContent = this.slides[this.index].getAttribute('aria-label');
    }
    refreshTimer() {
      clearInterval(this.timer);
      const running = !this.manualPause && !this.hover && !this.focused && this.inView && !document.hidden;
      this.toggle.textContent = this.manualPause ? '▷' : 'Ⅱ';
      this.toggle.setAttribute('aria-label',this.manualPause ? this.toggle.dataset.play : this.toggle.dataset.pause);
      if (running) this.timer = setInterval(() => this.go(this.index + 1, false), Number(this.dataset.interval) || 8000);
    }
    disconnectedCallback() {this.abort?.abort();this.abort = null;clearInterval(this.timer);clearTimeout(this.scrollTimer);this.observer?.disconnect();}
  });
}
